import { createReducer } from "redux-act";
import { SteeringDataAPI } from "@ai360/core";
import * as actions from "./actions";

export const STEERING_DATA_KEY = "STEERING_DATA";

export interface ISteeringDataState {
    records: SteeringDataAPI.ISteeringDataRecord[];
    selectedRecord: SteeringDataAPI.ISteeringDataRecord | null;
    loading: boolean;
    error: string | null;
}

const initialState: ISteeringDataState = {
    records: [],
    selectedRecord: null,
    loading: false,
    error: null,
};

export const steeringDataReducer = createReducer<ISteeringDataState>(
    {
        // Fetch List
        [actions.fetchSteeringDataList as any]: (state) => ({
            ...state,
            loading: true,
            error: null,
        }),
        [actions.fetchSteeringDataListSuccess as any]: (
            state,
            records: SteeringDataAPI.ISteeringDataRecord[]
        ) => ({
            ...state,
            records,
            loading: false,
            error: null,
        }),
        [actions.fetchSteeringDataListFailed as any]: (state, error: string) => ({
            ...state,
            loading: false,
            error,
        }),

        // Fetch Single Record
        [actions.fetchSteeringDataRecord as any]: (state) => ({
            ...state,
            loading: true,
            error: null,
        }),
        [actions.fetchSteeringDataRecordSuccess as any]: (
            state,
            record: SteeringDataAPI.ISteeringDataRecord
        ) => ({
            ...state,
            selectedRecord: record,
            loading: false,
            error: null,
        }),
        [actions.fetchSteeringDataRecordFailed as any]: (state, error: string) => ({
            ...state,
            loading: false,
            error,
        }),

        // Create
        [actions.createSteeringDataSuccess as any]: (
            state,
            record: SteeringDataAPI.ISteeringDataRecord
        ) => ({
            ...state,
            records: [...state.records, record],
            loading: false,
            error: null,
        }),
        [actions.createSteeringDataFailed as any]: (state, error: string) => ({
            ...state,
            loading: false,
            error,
        }),

        // Update
        [actions.updateSteeringDataSuccess as any]: (
            state,
            record: SteeringDataAPI.ISteeringDataRecord
        ) => ({
            ...state,
            records: state.records.map((r) =>
                r.steeringDataGuid === record.steeringDataGuid ? record : r
            ),
            selectedRecord:
                state.selectedRecord?.steeringDataGuid === record.steeringDataGuid
                    ? record
                    : state.selectedRecord,
            loading: false,
            error: null,
        }),
        [actions.updateSteeringDataFailed as any]: (state, error: string) => ({
            ...state,
            loading: false,
            error,
        }),

        // Delete
        [actions.deleteSteeringDataSuccess as any]: (state, guid: string) => ({
            ...state,
            records: state.records.filter((r) => r.steeringDataGuid !== guid),
            selectedRecord:
                state.selectedRecord?.steeringDataGuid === guid ? null : state.selectedRecord,
            loading: false,
            error: null,
        }),
        [actions.deleteSteeringDataFailed as any]: (state, error: string) => ({
            ...state,
            loading: false,
            error,
        }),

        // Loading / Error
        [actions.setSteeringDataLoading as any]: (state, loading: boolean) => ({
            ...state,
            loading,
        }),
        [actions.setSteeringDataError as any]: (state, error: string | null) => ({
            ...state,
            error,
        }),
    },
    initialState
);
